<template>
  <b-card>
    <div class="row">
      <div class="col-6 d-flex align-items-center justify-content-lg-start">
        <Button
          v-if="showBackButton && actionType === 'save' || 'add'"
          :label="$t('List page')"
          size="md"
          icon="ArrowLeftIcon"
          show-icon
          class="mb-1"
          @click="backNavigationAction"
        />
      </div>
      <div class="col-6 d-flex justify-content-end">
        <Button
          v-if="showSearchButton"
          :label="$t('Search')"
          size="md"
          icon="SearchIcon"
          show-icon
          @click="showSearchField"
        />
      </div>
    </div>

    <b-row class="match-height mt-1 mb-4">
      <b-col
        v-if="!showSearchButton"
        md="4"
      >
        <Alert
          :show="showFormErrorAlert"
          message="Customer's account name or account number or reference number is required"
        />
        <b-row>
          <b-col md="12">
            <InputField
              id="account-number"
              v-model="searchParams.accountNumber"
              :label="$t('Account Number')"
              :placeholder="$t('Enter account number')"
              type="number"
              :error-name="$t('Account Number')"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="account-name"
              v-model="searchParams.accountName"
              :label="$t('Account Name')"
              :placeholder="$t('Enter account name')"
              type="text"
            />
          </b-col>
          <b-col md="12">
            <InputField
              id="reference-number"
              v-model="searchParams.referenceNumber"
              :label="$t('Reference Number')"
              :placeholder="$t('Enter reference number')"
              type="number"
            />
          </b-col>
        </b-row>

        <Button
          :label="$t('Search')"
          size="md"
          class="mt-2"
          block
          @click="handleSearch"
        />
      </b-col>
      <b-col
        v-if="showSearchButton"
        :md="showSearchButton === true ? '12' : '8'"
      >
        <div v-if="showCustomerInfo">
          <validation-observer ref="lienRules">
            <b-form @submit.prevent="handleSubmit">
              <app-collapse
                class="business-items mb-4"
                type="margin"
                accordion
              >
                <app-collapse-item
                  :title="$t('Account Details')"
                  class="card-item"
                  is-visible
                >
                  <b-row class="match-height">
                    <!-- Account Name -->
                    <b-col md="4">
                      <InputField
                        id="account-name"
                        v-model="lienFormData.accountName"
                        :label="$t('Account Name')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Account Name -->

                    <!-- Customer Name -->
                    <b-col md="4">
                      <InputField
                        id="customer-name"
                        v-model="accountInfo.customerName"
                        :label="$t('Customer Name')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Customer Name -->

                    <!-- Product Name -->
                    <b-col md="4">
                      <InputField
                        id="product-name"
                        v-model="accountInfo.productName"
                        :label="$t('Product Name')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Product Name -->

                    <!-- Account Number -->
                    <b-col md="4">
                      <InputField
                        id="account-number"
                        v-model="lienFormData.accountNumber"
                        :label="$t('Account Number')"
                        type="number"
                        readonly
                      />
                    </b-col>
                    <!--  Account Number -->

                    <!-- Ledger Balance -->
                    <b-col md="4">
                      <InputField
                        id="ledger-balance"
                        v-model="customer.ledgerBalance"
                        :label="$t('Ledger Balance')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Ledger Balance -->

                    <!-- Available Balance -->
                    <b-col md="4">
                      <InputField
                        id="available-balance"
                        v-model="customer.availableBalance"
                        :label="$t('Available Balance')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Available Balance -->

                    <!-- Account Status -->
                    <b-col md="4">
                      <InputField
                        id="account-status"
                        v-model="accountInfo.accountStatus"
                        :label="$t('Account Status')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Account Status -->

                    <!-- Account Officer -->
                    <b-col md="4">
                      <InputField
                        id="account-officer"
                        v-model="accountInfo.accountOfficer"
                        :label="$t('Account Officer')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Account Officer -->

                    <!-- Overdraft Limit -->
                    <b-col md="4">
                      <InputField
                        id="overdraft-limit"
                        v-model="customer.overdraftLimit"
                        :label="$t('Overdraft Limit')"
                        type="text"
                        readonly
                      />
                    </b-col>
                    <!-- Overdraft Limit -->
                  </b-row>
                </app-collapse-item>
              </app-collapse>
              <b-row class="match-height">
                <!--  Form of Lien -->
                <b-col md="6">
                  <SelectField
                    id="form-of-lien"
                    v-model="lienFormData.formOfLien"
                    :label="$t('Form Of Lien')"
                    :options="translatedFormOfLienOptions"
                    :reduce="option => option.value"
                    :placeholder="$t('Select')"
                    :error-name="$t('Form Of Lien')"
                    rules="required"
                    item="label"
                    :set-selected="setFormOfLien"
                  />
                </b-col>
                <!--  Form of Lien -->

                <!--Amount-->
                <b-col md="6">
                  <InputNumberField
                    id="amount"
                    v-model.number="lienFormData.amount"
                    :label="$t('Amount')"
                    :error-name="$t('Amount')"
                    :rules="isFlatAmountRequired"
                    :readonly="isFlatAmount"
                    :is-allow-negative-numbers="false"
                    onpaste="return false;"
                  />
                </b-col>
                <!-- Amount -->

                <!-- Percentage -->
                <b-col md="6">
                  <InputField
                    id="percentage"
                    v-model.number="lienFormData.percentage"
                    :label="$t('Percentage')"
                    type="number"
                    :rules="isPercentageRequired"
                    :error-name="$t('Percentage')"
                    :readonly="isPercentage"
                    :is-allow-negative-numbers="false"
                    onpaste="return false;"
                  />
                </b-col>
                <!-- Percentage -->

                <!-- Description-->
                <b-col md="6">
                  <InputField
                    id="description"
                    v-model="lienFormData.description"
                    :label="$t('Description')"
                    type="text"
                    :error-name="$t('Description')"
                    rules="required"
                  />
                </b-col>
                <!--  Description -->

                <!-- Tenure -->
                <b-col md="6">
                  <InputNumberField
                    id="tenure"
                    v-model.number="lienFormData.tenure"
                    :label="$t('Tenure (In days)')"
                    type="number"
                    :error-name="$t('Tenure')"
                    rules="required|integer|positive"
                    :is-allow-negative-numbers="false"
                    onpaste="return false;"
                  />

                </b-col>
                <!-- Tenure -->

                <!-- Commencement Date-->
                <b-col md="6">
                  <DatePickerField
                    id="commencement-date"
                    v-model="lienFormData.commencementDate"
                    rules="required"
                    :label="$t('Commencement Date')"
                    :error-name="$t('Commencement Date')"
                    :config="datePickerConfig"
                    :placeholder="$t('Select Date')"
                  />
                </b-col>
                <!--  Commencement Date -->
              </b-row>
              <div class="text-center mt-5">
                <Button
                  :label="$t('Save')"
                  :loading="isLoading"
                  :disabled="isDisabled"
                  variant="primary"
                  size="lg"
                  @click="handleSubmit"
                />
              </div>
            </b-form>
          </validation-observer>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="search-modal"
      ref="search-modal"
      centered
      size="lg"
      :title="$t('Search Result')"
      ok-only
      :ok-title="$t('Cancel')"
      ok-variant="outline-secondary"
    >
      <b-table
        ref="customerListTable"
        :items="customerList"
        responsive
        :fields="translatedTableHeaders"
        primary-key="id"
        show-empty
        selectable
        :empty-text="$t('No result found')"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="position-relative"
        @row-selected="onSelectCustomer"
      >

        <template #cell(SN)="data">
          {{ getOverallIndex(data.index) }}
        </template>

        <template #cell(accountStatus)="data">
          <b-badge
            pill
            :variant="getStatusColor(data.value)"
          >
            {{ data.value }}
          </b-badge>
        </template>
      </b-table>

      <TablePagination
        v-model="currentPage"
        :from="from"
        :to="to"
        :total-rows="totalEntries"
        :per-page="perPage"
      />

      <template
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BBadge,
  BModal, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, maxValue, positive } from '@validations'
import { heightFade } from '@core/directives/animations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions } from 'vuex'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TablePagination from '@/views/components/table/TablePagination.vue'
import { toBalance, toKobo } from '@/helpers/formatAmount'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import DatePickerField from '../../../../forms/DatePickerField.vue'
import getStatusColor from '../../../../../helpers/getStatusColor'
import { toYearWithDate } from '../../../../../helpers/formatDate'
import Button from '../../../../components/button/Button.vue'
import Alert from '../../../../components/alert/Alert.vue'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BBadge,
    BCol,
    Button,
    BTable,
    BModal,
    Alert,
    BForm,
    ValidationObserver,
    InputNumberField,
    InputField,
    DatePickerField,
    SelectField,
    TablePagination,
    FullScreenSpinner,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert],
  data() {
    return {
      showCustomerInfo: false,
      showSearchButton: false,
      showBackButton: false,
      isFlatAmountRequired: '',
      isPercentageRequired: '',
      isLoading: false,
      isDisabled: false,
      maxValue,
      positive,
      sortBy: 'accountName',
      showFormErrorAlert: false,
      showSpinner: false,
      showTable: false,
      required,
      isFlatAmount: false,
      isPercentage: false,
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        ariaDateFormat: 'd/m/Y',
      },
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'customerID', sortable: true, label: 'Customer ID' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountType', sortable: true, label: 'Account Type' },
        { key: 'accountStatus', sortable: true, label: 'Account Status' },
      ],
      searchParams: {
        accountNumber: '',
        accountName: '',
        referenceNumber: '',
      },
      accountInfo: {
        accountName: '',
        customerName: '',
        productName: '',
        accountNumber: '',
        accountStatus: '',
        accountOfficer: '',
      },
      customer: {
        ledgerBalance: '',
        availableBalance: '',
        overdraftLimit: '',
      },
      lienFormData: {
        accountNumber: '',
        accountName: '',
        formOfLien: 'FlatAmount',
        amount: null,
        percentage: null,
        description: '',
        tenure: null,
        commencementDate: '',
      },
      maturityDate: null,
      getStatusColor,
      formOfLienOptions: [
        { label: 'Flat amount', value: 'FlatAmount' },
        { label: 'Percentage of balance', value: 'PercentageOfBalance' },
      ],
      filteredResult: [],
      customerList: [],
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    translatedFormOfLienOptions() {
      return this.formOfLienOptions.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  methods: {
    ...mapActions({
      createLien: 'account/createLienAction',
      searchCustomerAccount: 'account/searchCustomerAccountAction',
      getUserBalance: 'account/getCASABalanceAction',
    }),
    setFormOfLien(selectedValue) {
      if (selectedValue === 'FlatAmount') {
        this.isFlatAmount = false
        this.isPercentage = true
        this.lienFormData.percentage = '0'
        this.isFlatAmountRequired = 'required|positive'
        this.isPercentageRequired = ''
      } else {
        this.isPercentage = false
        this.isFlatAmount = true
        this.lienFormData.amount = 0
        this.isFlatAmountRequired = ''
        this.isPercentageRequired = 'required|positive|max-value:100'
      }
    },
    showSearchField() {
      this.showSearchButton = false
      this.resetSearchParams()
    },
    async handleSearch() {
      try {
        const isSearchParamsNotEmpty = Object.values(this.searchParams).every(params => (params === null || params === ''))
        if (!isSearchParamsNotEmpty) {
          this.showFormErrorAlert = false
          this.showSpinner = true
          const response = await this.searchCustomerAccount({
            search: this.searchParams,
            page: this.currentPage,
            limit: this.perPage,
            permission: accountPermissions.CREATE_LIEN,
          })
          const { data } = await response
          this.customerList = data.data
          this.totalCount = data.recordCount
          this.showSpinner = false
          this.$root.$emit('bv::show::modal', 'search-modal')
        } else {
          this.showFormErrorAlert = true
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async onSelectCustomer(items) {
      const customerInfo = items[0]
      this.accountInfo = {
        ...customerInfo,
        accountOfficer: customerInfo.accountOfficerName,
      }
      const response = await this.getUserBalance({ accountNumber: customerInfo.accountNumber, permission: accountPermissions.CREATE_LIEN })
      const { data, status } = response
      if (status === 200) {
        this.customer = {
          ledgerBalance: toBalance(data.ledgerBalance),
          availableBalance: toBalance(data.availableBalance),
          overdraftLimit: toBalance(data.overdraftLimit),
        }
      }
      this.lienFormData.accountNumber = customerInfo.accountNumber
      this.lienFormData.accountName = customerInfo.accountName
      this.setFormOfLien('FlatAmount')
      this.showCustomerInfo = true
      this.showSearchButton = true
      this.showBackButton = true
      this.$bvModal.hide('search-modal')
    },
    async createLienAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const response = await this.createLien({
          ...this.lienFormData,
          amount: toKobo(this.lienFormData.amount),
          commencementDate: toYearWithDate(this.lienFormData.commencementDate),
        })
        const { status } = await response
        if (status === 200) {
          this.showCustomerInfo = false
          this.resetLienFormData()
          this.resetSearchParams()
          this.alertSuccess({ text: this.$t('Your request to Save Lien was successful') })
          this.$router.push({ name: 'liens' })
        }
      } catch (error) {
        this.alertError({ text: error })
        this.isLoading = false
        this.isDisabled = false
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async handleSubmit() {
      this.$refs.lienRules.validate().then(async success => {
        if (success) {
          this.confirm(this.createLienAction, { text: this.$t('Are you sure you want to Save this Lien?') })
        }
      })
    },
    resetLienFormData() {
      this.lienFormData = { ...null }
    },
    resetSearchParams() {
      this.searchParams = { ...null }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'liens',
      })
    },
  },
}
</script>
<style scoped>
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
